import { createContext, useContext } from 'react';
import type { CatalogueDesignKey } from './designs';

export interface CatalogueAppearanceContextValue {
  design: CatalogueDesignKey;
  setDesign: (design: CatalogueDesignKey) => void;
}

export const CatalogueAppearanceContext = createContext<CatalogueAppearanceContextValue | null>(null);

export const useCatalogueAppearance = () => {
  const ctx = useContext(CatalogueAppearanceContext);
  if (!ctx) {
    throw new Error('CatalogueAppearanceContext no está disponible');
  }
  return ctx;
};

export const useOptionalCatalogueAppearance = () => useContext(CatalogueAppearanceContext);
